export class BookingStatusResponse {

  public statusId?: number;
  public message?: string;
  public waitTime?: number;
  public therapistId?: number;
  public therapistFirstName?: string;
  public therapistLastName?: string;
  public therapistProfileLargeURL?: string;
  public mobileNumber?: string;
  public contactMethodId?: number;
  public contactMethodName?: string;
  public queuePosition?: number;
}
